import { queryOptions } from '@tanstack/react-query';
import { getHomeLayouts } from '~/apis/mercari';

export const homeLayoutQueryOptions = queryOptions({
  queryKey: ['home', 'shortcuts'],
  queryFn: () => getHomeLayouts(),
  select: (data) => data?.data,
  staleTime: 1000 * 300, // 숏컷은 변경 가능성이 낮기 때문에 5분으로 설정
});
